"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinchZoomHandlerCartesian2d = void 0;
const rc_js_util_1 = require("rc-js-util");
const cartesian_user_interaction_transform_provider_1 = require("./cartesian-user-interaction-transform-provider");
/**
 * @public
 * User interaction handler for pinch zooming.
 */
class PinchZoomHandlerCartesian2d {
    constructor(plot, canvasDims, centerPointCssCanvas, prevWidth) {
        this.plot = plot;
        this.canvasDims = canvasDims;
        this.prevWidth = prevWidth;
        this.scaleAbout = new rc_js_util_1.Vec2.f32();
        this.canvasToDataTransform = rc_js_util_1.Mat3.f32.factory.createOneEmpty();
        this.dataRangeTmp = this.plot.plotRange.dataRange.slice();
        this.previousCenterPoint = centerPointCssCanvas.slice();
        this.userTransformProvider = new cartesian_user_interaction_transform_provider_1.CartesianUserInteractionTransformProvider(plot);
    }
    onPanZoomChange(cssCenterPoint, distanceBetweenPoints) {
        const dataRange = this.plot.plotRange.dataRange;
        const previousCenterPoint = this.previousCenterPoint;
        const dd = this.userTransformProvider.getTransformedDelta(cssCenterPoint, this.plot.plotDimensionsOBL.pixelArea.interactiveRange, previousCenterPoint.getX() - cssCenterPoint.getX(), previousCenterPoint.getY() - cssCenterPoint.getY());
        previousCenterPoint.set(cssCenterPoint);
        this.dataRangeTmp.set(dataRange);
        this.plot.plotDimensionsOBL.cssArea.interactiveRange.getRangeTransform(this.dataRangeTmp, this.canvasToDataTransform);
        cssCenterPoint.mat3Multiply(this.canvasToDataTransform, this.scaleAbout);
        this.scaleAbout.bound2d(this.dataRangeTmp);
        this.dataRangeTmp.scaleRelativeTo(this.prevWidth / distanceBetweenPoints, this.scaleAbout, this.dataRangeTmp);
        this.dataRangeTmp.translateBy(-dd[0] * this.canvasDims.dpr, -dd[1] * this.canvasDims.dpr);
        this.plot.plotRange.updateDataRange(this.dataRangeTmp);
        this.prevWidth = distanceBetweenPoints;
    }
}
exports.PinchZoomHandlerCartesian2d = PinchZoomHandlerCartesian2d;
//# sourceMappingURL=pinch-zoom-handler-cartesian2d.js.map